<template>
  <div style="padding: 1px;">
    <div style="width: 500px; height: 500px; margin: 150px auto;color:#ccc;font-size:46px;">
      欢迎来到泡芙教育
    </div>
  </div>
</template>

<script>
export default {
  name: 'dashboard'
}
</script>

<style scoped>

</style>
